import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const MonedaApp = lazy(() => import('./view/Moneda'))

export const monedaRoutesMap = {
  moneda: {
    path: '/moneda/gestion',
    name: 'Monedas de comercio',
    action: 'MONEDAS_DE_MONEDAS',
  },
  administrar: {
    name: 'Administrar monedas',
    action: 'ADMINISTRAR_MONEDAS_COMERCIO',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const monedaRoutes = [
  {
    path: monedaRoutesMap.moneda.path,
    element: (
      <OperacionesProvider>
        <MonedaApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default monedaRoutes
